import React from 'react';
import useEditorStore from '../../store/editorStore';
import './GridOverlay.css';

function GridOverlay() {
  const { canvas, grid } = useEditorStore();

  if (!grid.visible) return null;

  const gridSize = grid.size;
  const cols = Math.ceil(canvas.width / gridSize);
  const rows = Math.ceil(canvas.height / gridSize);

  return (
    <div className="grid-overlay">
      <svg
        width={canvas.width}
        height={canvas.height}
        style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none' }}
      >
        <defs>
          <pattern
            id="grid"
            width={gridSize}
            height={gridSize}
            patternUnits="userSpaceOnUse"
          >
            <path
              d={`M ${gridSize} 0 L 0 0 0 ${gridSize}`}
              fill="none"
              stroke="rgba(0, 0, 0, 0.1)"
              strokeWidth="0.5"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid)" />
      </svg>
    </div>
  );
}

export default GridOverlay;
